/* eslint-disable react-hooks/set-state-in-effect -- this input intentionally mirrors external value changes from an effect. */
import styled from "styled-components";
import {useEffect, useRef, useState} from "react";
import type {IInputPropsV5} from "../../../widgets/input/clicktoedit/InputUtils";
import {useAppStore} from "../../../../StateManager";
import {useCloseOnKeyboardPress} from "../../utils";
import {baseDistance, ELLIPSIS, radius} from "../../styles/styles";
import {KeyboardListener} from "../../../../utils/interaction/key/KeyboardListener";
import {colorPalette} from "../../styles/colorPalette";
import {TextInputV5} from "./TextInputV5";

export const SingleLineInputV5 = (props: IInputPropsV5) => {
	const {value, onInput, onBlur, disabled, inputType, onClick, onChange, focused, getErrorMessage, updateLastValidOnInput} = props;
	const appState = useAppStore((state) => state.appState);
	const [isActive, setIsActive] = useState<boolean>(false);
	const inputRef = useRef<HTMLDivElement>(null);
	const final = appState.actions.getURLsInTextInputs(value);
	let isURL = typeof final === "string" ? final.includes("//") : false; // Checking if the value protocol relative URL

	const onClickElement = () => {
		setIsActive(true);
	};

	const onBlurElement = () => {
		setIsActive(false);
		onBlur?.();
	};

	const onKeyboardPress = () => {
		if (isActive) {
			setIsActive(false);
		}
	};

	useEffect(() => {
		if (focused) {
			setIsActive(true);
		}
	}, [focused]);

	useCloseOnKeyboardPress(onKeyboardPress, KeyboardListener.KEY_ENTER, [], {enabled: isActive});
	useCloseOnKeyboardPress(onKeyboardPress, KeyboardListener.KEY_ESCAPE, [], {enabled: isActive});

	return isActive ? (
		<SingleLineInputStyled
			ref={inputRef}
			className="hbox field-input-container"
		>
			<TextInputV5
				value={value}
				onInput={onInput}
				onClick={onClick}
				onChange={onChange}
				autoFocus={true}
				disabled={disabled}
				inputType={inputType}
				onBlur={onBlurElement}
				getErrorMessage={getErrorMessage}
				updateLastValidOnInput={updateLastValidOnInput}
			/>
		</SingleLineInputStyled>
	) : isURL ? (
		<SingleLineLabelStyled onClick={onClickElement}>
			<div className="content">
				<a
					href={final}
					target="_blank"
				>
					{value}
				</a>
			</div>
		</SingleLineLabelStyled>
	) : (
		<SingleLineLabelStyled onClick={onClickElement}>
			<div className="content">{final}</div>
		</SingleLineLabelStyled>
	);
};

export const SingleLineInputStyled = styled.div`
	display: flex;
	align-items: center;
`;

export const SingleLineLabelStyled = styled.div`
	display: flex;
	align-items: center;
	cursor: text;
	height: 100%;
	border: 1px solid ${colorPalette.gray.c300};
	border-radius: ${radius.sm};
	min-height: 32px;

	.content {
		${ELLIPSIS}
		max-height: 82px;
		position: relative;
		line-height: ${baseDistance.md};
		margin: ${baseDistance.sm};
	}
`;
